// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsCustomization from '../../api/actionsCustomization';
// Components
import { Modal, ModalBody, ModalContent } from '../../../../../../common-utils/components/ui/modal';
import HeaderTitle from '../../../../../../common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '../../../../../../common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '../../../../../../common-utils/components/renders/entity/Entity';
// Common
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsCustomization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.customization
 * @param root0.setLaunchRefetch
 * @returns {JSX} ModalDeleteCustomization
 */
function ModalDeleteCustomization({ isOpen, setIsOpen, customization, setLaunchRefetch }) {
    // Toast
    const { toast } = useToast();

    // State
    const [showSubmitButton, setShowSubmitButton] = useState(true);

    // Format date
    const updatedDate = new Date(customization?.updatedAt);
    const formattedUpdatedDate = new Intl.DateTimeFormat('fr-FR').format(updatedDate);

    // Api calls
    const onSuccess = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity entity='modal.delete.success' namespace={nsCustomization} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.delete.error' namespace={nsCustomization} />,
            variant: 'danger'
        });
    };
    const submitDeleteCustomization = actionsCustomization.deleteCustomization(onSuccess, onError);

    // Functions
    const onSubmit = () => {
        submitDeleteCustomization.mutate({ uuid: customization.uuid });
    };
    const onClose = () => {
        setIsOpen(false);
        if (submitDeleteCustomization.isSuccess) {
            setLaunchRefetch(true);
        }
    };

    return <Modal open={isOpen} onOpenChange={onClose}>
        <ModalContent className='max-w-2xl' >
            <HeaderTitle title='modal.delete.title' namespace={nsCustomization} />
            <ModalBody>
                <div className='text-center flex flex-col items-center pb-5 gap-5'>
                    <div className='flex flex-col items-center gap-2.5'>
                        <div className='flex items-center gap-2 justify-center'>
                            <Entity entity='modal.delete.update_date' namespace={nsCustomization} />:
                            <span>{formattedUpdatedDate}</span>
                        </div>
                        <div className='flex items-center gap-2 justify-center'>
                            <Entity entity='modal.delete.status' namespace={nsCustomization} />:
                            <Entity
                                entity={customization?.packageCode ? 'status.PUBLISHED' : 'status.DRAFT'}
                                namespace={nsCustomization}
                            />
                        </div>
                    </div>
                    <div
                        className='rounded w-12 h-10 flex items-center justify-center'
                        style={{ backgroundColor: customization.color || '#f3f4f6' }}
                    >
                        {
                            customization.logo &&
                            <img
                                className='mt-1 max-w-[30px] max-h-[30px] object-contain'
                                src={customization.logo}
                                alt='Logo'
                            />
                        }
                    </div>
                    <div>
                        <Entity
                            entity='modal.delete.confirm'
                            namespace={nsCustomization}
                            data={{ packageLabel: customization?.packageLabel }}
                        />
                    </div>
                </div>
            </ModalBody>
            <FooterForm
                onSubmit={onSubmit}
                isSubmitting={submitDeleteCustomization.isLoading}
                showSubmitButton={showSubmitButton}
                submitButtonVariant='danger'
            />
        </ModalContent>
    </Modal>;
}

ModalDeleteCustomization.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    customization: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func
};

export default ModalDeleteCustomization;